import AxiosPipeline from '@/services/api/pipeline/axios_pipeline'

export default {
  createPipeline: (data) => {
    return AxiosPipeline.post('pipeline', data)
  },

  updatePipeline: (pipelineId, data) => {
    return AxiosPipeline.put(`pipeline/${pipelineId}`, data)
  },

  getAllPipelines: (params) => {
    return AxiosPipeline.get('pipeline', {params})
  },

  getPipeline: (pipelineId) => {
    return AxiosPipeline.get(`pipeline/${pipelineId}`)
  },

  deletePipeline: (pipelineId) => {
    return AxiosPipeline.delete(`pipeline/${pipelineId}`)
  }
}
